const getNeologyConfig = nodeEnv => {
    let baseURL;
    let proxyPrefix;
    switch (nodeEnv) {
        // dev
        case "dev":
        case "sit":
            baseURL = "https://neology-test.beautyfarm.com.cn";
            proxyPrefix = "";
            break;
        // 预发布
        case "pre":
            baseURL = "https://neology-pre.beautyfarm.com.cn";
            proxyPrefix = "";
            break;
        // 正式
        case "prod":
            baseURL = "https://neology.beautyfarm.com.cn";
            proxyPrefix = "";
            break;
        // 默认
        default:
            baseURL = "http://localhost:8080";
            proxyPrefix = "/yapi";
            break;
    }
    return { baseURL, proxyPrefix };
};

export default getNeologyConfig;



// WEBPACK FOOTER //
// ./src/api/neology/config.js